import React, {Component} from 'react'
import { Link } from 'react-router'
import iconLight from './icon-light.svg'
import risqoverWhite from './risqover-white.svg'
import { Menu, Dropdown } from 'semantic-ui-react'
// import {logout} from '../../../actions'
import {connect} from 'react-redux'
import {logOutAction} from '../../../actions/account.action'
const Item = Menu.Item

class Header extends Component {
  constructor (props) {
    super(props)
    this.state = {
      header_items: 10
    }
  }
  componentDidMount () {
    window.addEventListener('resize', this.calculateHeaderItems.bind(this));
    this.calculateHeaderItems()
  }
  calculateHeaderItems() {
    let currentWidth = window.innerWidth
    let headerLen = 140
    let count = 1
    if (currentWidth <= 784) {
      count = 4
    } else {
      for (let i = 0; i < this.props.templates.length; i++) {
        let nameLength = this.props.templates[i].name.length
        if (headerLen + nameLength * 6.33 + 32 >= currentWidth) {
          break
        }
        count = i+1
        headerLen += nameLength*6.33+32
      }
    }
    this.setState({
      header_items: count
    })
  }

  handleLogout (e) {
    e.preventDefault()
    this.props.logOutAction()
  }
  render () {
    const HEADER_ITEMS = this.state.header_items
    return (
      // tweak for fixed based on size will not update when resizing window but thats totally fine for now
      <Menu inverted className='app-header fac-brand no-print' stackable fixed={window.innerWidth > 768 ? 'top' : null}>
        {/*<Item className='icon-holder-mobile'>*/}
        {/*  <img className='risqover-icon-mobile' src={risqoverWhite} />*/}
        {/*</Item>*/}
        {/*<Item className='icon-holder' style={{position: 'absolute', left: '0', right: '0', marginLeft: 'auto', marginRight: 'auto', width: '150px'}}>*/}
        {/*  <img className='risqover-icon' src={risqoverWhite} />*/}
        {/*</Item>*/}
        {
          this.props.templates.map((template, index) => {
            if (index >= HEADER_ITEMS) return
            return (<Link className='item' activeClassName='active' key={template._id}
              to={'/issues/overview/' + template._id}>{template.name}</Link>)
          }
          )
        }
        {
          this.props.templates.length > HEADER_ITEMS ? (
            <Dropdown item style={{ marginRight: '20px'}} position='right' text='More' simple>
              <Dropdown.Menu>
                {
                  this.props.templates.map((template, index) => {
                    if (index < HEADER_ITEMS) return
                    return (<Link className='item' activeClassName='active' key={template._id}
                      to={'/issues/overview/' + template._id}>{template.name}</Link>)
                  }
                  )
                }
              </Dropdown.Menu>
            </Dropdown>
          ) : undefined
        }

        <Menu.Menu position='right'>
          <Dropdown item icon='setting' direction='right' simple>
            <Dropdown.Menu>
              <Link className='item' activeClassName='active' to='/settings/profile'>Profile</Link>
              <Link className='item' activeClassName='active' to='/settings/billing'>Billing</Link>
              {/* <Link className='item' activeClassName='active' to='/settings/company'>Company</Link> */}
              <Link className='item' activeClassName='active' to='/settings/devices'>Devices</Link>
              <Link className='item' activeClassName='active' to='/settings/team'>Team</Link>
              <Link className='item' activeClassName='active' to='/settings/templates'>Forms</Link>
              <Dropdown.Divider/>
              <Dropdown.Item onClick={this.handleLogout.bind(this)}>Log out</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Menu.Menu>

        <style type='text/css'>{`.fac-brand{background-color:#000000 !important}`}</style>
        <style type='text/css'>{`.risqover-icon{width:150px !important}`}</style>
        <style type='text/css'>{`.icon-holder-mobile{display:none !important}`}</style>
        <style type='text/css'>{`.risqover-icon-mobile{width:100px !important}`}</style>
        <style>
          {`
          @media (max-width: 770px) {
            .icon-holder{
              display:none !important
            }
            .icon-holder-mobile{
              display: block !important
            }
          }

          @media (max-width: 1200px) {
            .icon-holder{
            }
          }

          @media print{
           .no-print{
               display:none !important
           }
          }
          `
          }
        </style>
      </Menu>
    )
  }
}

function mapStateToProps (state) {
  return {templates: state.templates.templates}
}

export default connect(mapStateToProps, {logOutAction})(Header)



// WEBPACK FOOTER //
// ./src/containers/appshell/header/index.js